import { useQuery } from '@tanstack/react-query'

export const useScrapeHtml = (pathname: string) =>
  useQuery([`${pathname}_html`], () => fetch(pathname).then((response) => response.text()))
